const isStaticServiceHostedAsset = assetPath =>
  assetPath.startsWith("/files/static");

module.exports = { isStaticServiceHostedAsset };
